import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { DividendVipService } from 'src/app/pages/dividend-vip/dividend-vip.service';
import { ChatService } from 'src/app/shared/service/chat.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { LeftMenuService } from '../left-menu/left-menu.service';

@UntilDestroy()
@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss'],
})
export class BottomMenuComponent implements OnInit {
  isH5!: boolean;
  /** 隱藏底部菜單 'register', 'login', 'password' */
  hide!: boolean;
  /** 收起底部菜單 */
  active: boolean = true;
  loggedIn!: boolean;
  hasPromo!: boolean;

  /** 侧边栏状态 */
  leftBarStatus: boolean = this.localStorageService.getValueByJsonParse('platform-left-menu-state');

  /** 底部菜单导航 */
  bottomMenuItem: Array<{
    menuItemName?: string;
    icon?: string;
    routerLink?: string;
    menuIcon?: string;
    order: number;
  }> = [{ order: 2 }, { order: 4 }, { order: 5 }];

  isBottomMenuReady: boolean = false;

  constructor(
    public layout: LayoutService,
    public chatService: ChatService,
    public route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private leftMenuService: LeftMenuService,
    private appService: AppService,
    private platform: Platform,
    private deviceService: DeviceDetectorService,
    private dividendVipService: DividendVipService,
  ) {}

  get hasChatUnread(): boolean {
    return !!(this.loggedIn && this.chatService.chatEnabled && this.chatService.unreadCount > 0);
  }

  originalHeight = 0;
  androidHandle = () => {
    const tagName = document.activeElement?.tagName;
    const curHeight = document.documentElement.clientHeight || document.body.clientHeight;
    if (curHeight > this.originalHeight && (tagName === 'INPUT' || tagName === 'TEXTAREA')) {
      //android软键盘弹出
      this.active = false;
      this.layout.h5Keyboard$.next(true);
    } else if (!this.active) {
      //android软键盘收起
      this.active = true;
      this.layout.h5Keyboard$.next(false);
    }
  };
  iosFocusinHandle = () => {
    const tagName = document.activeElement?.tagName;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
      // ios软键盘弹起
      this.active = false;
      this.layout.h5Keyboard$.next(true);
    } else if (!this.active) {
      // 不是真的输入框（软键盘已收起），重置
      this.active = true;
      this.layout.h5Keyboard$.next(false);
    }
  };
  iosFocusoutHandle = () => {
    if (!this.active) {
      // 软键盘已收起，重置
      this.active = true;
      this.layout.h5Keyboard$.next(false);
    }
  };

  showMenuDot(): boolean {
    // 聚合 VIP Chat 未读、最新优惠（promotion）；后续其他项用 || 追加即可
    return !!(this.hasChatUnread || this.hasPromo);
  }

  ngOnInit() {
    this.appService.userInfo$
      .pipe(
        map(v => !!v),
        distinctUntilChanged(),
        filter(Boolean),
        untilDestroyed(this),
      )
      .subscribe(() => this.dividendVipService.getActivityCount());

    combineLatest([this.appService.userInfo$.pipe(map(v => !!v)), this.dividendVipService.activityCount$])
      .pipe(untilDestroyed(this))
      .subscribe(([loggedIn, promo]) => {
        this.loggedIn = loggedIn;
        this.hasPromo = loggedIn && promo > 0;
      });

    // 订阅是否h5
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => {
      document.body.removeEventListener('focusin', this.iosFocusinHandle);
      document.body.removeEventListener('focusout', this.iosFocusoutHandle);
      window.removeEventListener('resize', this.androidHandle);
      this.isH5 = e;
      const isMobile = this.deviceService.isMobile();
      // h5模式且是移动设备时候才生效
      if (e && isMobile) {
        if (this.platform.IOS) {
          document.body.addEventListener('focusin', this.iosFocusinHandle);
          document.body.addEventListener('focusout', this.iosFocusoutHandle);
        } else {
          this.originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
          window.addEventListener('resize', this.androidHandle);
        }
      } else {
        this.active = true;
        this.layout.h5Keyboard$.next(false);
      }
    });

    this.layout.leftMenuState$.pipe(untilDestroyed(this)).subscribe(data => {
      this.leftBarStatus = data;
    });

    this.leftMenuService
      .onGetTags()
      .pipe(
        untilDestroyed(this),
        map(v => {
          const headerMenu = v?.headerMenus || [];
          return headerMenu
            ?.filter(x => x.key !== '0')
            ?.map((x, index) => ({
              menuItemName: x?.name || '',
              icon: x?.icon || '',
              routerLink: `/${this.appService.languageCode}/${this.leftMenuService.getLinkByMethod(x)}`,
              menuIcon: x?.menuIcon || '',
              order: index === 0 ? 2 : index === 1 ? 4 : 5,
            }))
            .slice(0, 3);
        }),
      )
      .subscribe(data => {
        this.bottomMenuItem = data;
        if (data.length) this.isBottomMenuReady = true;
      });
  }
}
